<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'WhereFilter',
          label: 'ID',
          attributes: 'user_id'
        },
        {
          type: 'WhereLikeFilter',
          label: 'E-Mail-Adresse',
          attributes: 'user.email'
        },
        {
          type: 'WhereLikeFilter',
          label: 'Name',
          attributes: 'user.name'
        },
        {
          id: 0,
          type: 'SelectFilter',
          label: 'Agentur',
          options: agencyOptions,
          attributes: 'agency_id'
        }
      ]"
      v-model="filter"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <v-table
      url="/api/v1/moderator"
      :filter="filter"
      :appends="['last_login_ip_and_country', 'last_ping']"
      :additionalRequestData="{ hidden: ['in', 'out'] }"
      :row-classes="{
        'table-warning': model => {
          return Boolean(model.user && model.user.disabled_at);
        },
        'table-danger': model => {
          return Boolean(model.deleted_at);
        }
      }"
      :attributes="[
        {
          attribute: 'user.id',
          name: 'ID',
          sortable: false
        },
        {
          name: 'Moderator',
          type: 'UserNoEmailCell',
          attribute: 'user',
          sortable: false
        },
        {
          name: 'Letzter Login von',
          attribute: 'last_login_ip_and_country',
          type: 'IpCell',
          sortable: false
        },
        {
          attribute: 'user.id',
          name: 'Aktiv',
          type: 'OnlineCell',
          sortable: false
        },
        {
          name: 'Letzte Aktivität',
          attribute: 'last_activity',
          type: 'DateTimeCell'
        },
        {
          attribute: 'agency.name',
          name: 'Agentur',
          sortable: false
        },
        {
          name: 'Aktionen',
          type: 'ModeratorActionCell'
        },
        {
          name: 'Ping',
          type: 'PingCell',
          attribute: 'last_ping'
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    url: {
      type: String,
      required: false,
      default: '/api/v1/moderator'
    }
  },
  data () {
    return {
      filter: [
          {
            name: 'with',
            value: ['user', 'agency']
          },
      ]
    };
  },
  computed: {
    agencyOptions () {
      let agencyOptions = [{ value: null, label: "Alle" }];
      let agencies = this.$store.getters["agency/agencys"];
      agencies.forEach(agency => {
        agencyOptions.push({value: agency.id, label: agency.name});
      });
      return agencyOptions;
    },
  },
  created () {
    this.$store.dispatch("agency/read");
  }
};
</script>
